import {
  BusinessPartner,
  CountryResponsibility,
  OpenJob,
  OrganisationTree,
  Position,
  SpecialResponsibility
} from '../../api/generated';

export class LoadRootOrganisation {
  static readonly type = '[Org Management] Load Root Organisation';
}

export class RootOrganisationLoaded {
  static readonly type = '[Org Management] Root Organisation Loaded';

  constructor(public readonly rootOrganisation: OrganisationTree) {}
}

export class LoadOrganisationTree {
  static readonly type = '[Org Management] Load Organisation Tree';

  constructor(public readonly organisationId: string) {}
}

export class OrganisationTreeLoaded {
  static readonly type = '[Org Management] Organisation Tree Loaded';

  constructor(
    public readonly organisationId: string,
    public readonly organisationTree: OrganisationTree
  ) {}
}

export class LoadBusinessPartners {
  static readonly type = '[Org Management] Load Business Partners';

  constructor(public readonly organisationId: string) {}
}

export class BusinessPartnersLoaded {
  static readonly type = '[Org Management] Business Partners loaded';

  constructor(
    public readonly organisationId: string,
    public readonly businessPartners: BusinessPartner[]
  ) {}
}

export class LoadSpecialResponsibilities {
  static readonly type = '[Org Management] Load Special Responsibilities';

  constructor(public readonly organisationId: string) {}
}

export class SpecialResponsibilitiesLoaded {
  static readonly type = '[Org Management] Special Responsibilities loaded';

  constructor(
    public readonly organisationId: string,
    public readonly specialResponsibilities: SpecialResponsibility[]
  ) {}
}

export class LoadCountryResponsibilities {
  static readonly type = '[Org Management] Load Country Responsibilities';

  constructor(public readonly organisationId: string) {}
}

export class CountryResponsibilitiesLoaded {
  static readonly type = '[Org Management] Country Responsibilities loaded';

  constructor(
    public readonly organisationId: string,
    public readonly countryResponsibilities: CountryResponsibility[]
  ) {}
}

export class LoadPositions {
  static readonly type = '[Org Management] Load Positions';

  constructor(public readonly organisationId: string) {}
}

export class PositionsLoaded {
  static readonly type = '[Org Management] Positions Loaded';

  constructor(
    public readonly organisationId: string,
    public readonly positions: Position[]
  ) {}
}

export class LoadOpenJobs {
  static readonly type = '[Org Management] Load Open Jobs';

  constructor(public readonly organisationId: string) {}
}

export class OpenJobsLoaded {
  static readonly type = '[Org Management] Open Jobs Loaded';

  constructor(
    public readonly organisationId: string,
    public readonly openJobs: OpenJob[]
  ) {}
}
